<script>
export default {
	methods: {
		$hasRole(roleName) {
			if (this.$store.getters.getUserRole != undefined && this.$store.getters.getUserRole != null) {
				return this.$store.getters.getUserRole.includes(roleName);
			}
			return false;
		},
	},
};
</script>
